import { ParsedAddress } from "../dtos/ParsedAddress";

class AddressParser {
    public readonly stateConversionMap = {
        CAN: {
            AB: "AB",
            BC: "BC",
            MB: "MB",
            NB: "NB",
            NL: "NL",
            NT: "NT",
            NS: "NS",
            NU: "NU",
            ON: "ON",
            PE: "PE",
            QC: "QC",
            SK: "SK",
            YT: "YT"
        },
        USA: {
            AK: "AK",
            AL: "AL",
            AR: "AR",
            AS: "AS",
            AZ: "AZ",
            CA: "CA",
            CO: "CO",
            CT: "CT",
            DC: "DC",
            DE: "DE",
            FL: "FL",
            GA: "GA",
            GU: "GU",
            HI: "HI",
            IA: "IA",
            ID: "ID",
            IL: "IL",
            IN: "IN",
            KS: "KS",
            KY: "KY",
            LA: "LA",
            MA: "MA",
            MD: "MD",
            ME: "ME",
            MI: "MI",
            MN: "MN",
            MO: "MO",
            MP: "MP",
            MS: "MS",
            MT: "MT",
            NC: "NC",
            ND: "ND",
            NE: "NE",
            NH: "NH",
            NJ: "NJ",
            NM: "NM",
            NV: "NV",
            OH: "OH",
            OK: "OK",
            OR: "OR",
            PA: "PA",
            PR: "PR",
            RI: "RI",
            SC: "SC",
            SD: "SD",
            TN: "TN",
            TX: "TX",
            UT: "UT",
            VA: "VA",
            VI: "VI",
            VT: "VT",
            WA: "WA",
            WI: "WI",
            WV: "WV",
            WY: "WY"
        }
    }

    public parseUsaAddress(description: string, text: string): ParsedAddress {
        try {
            const address = {
                streetAddress: "",
                country: "",
                state: "",
                city: "",
                zipCode: "",
                moreAddresses: false,
                id: ""
            }
            address.streetAddress = text;
            let data = description.split(" ");
            address.zipCode = data[data.length - 1]
            data = data.slice(0, data.length - 1);
            address.state = this.stateConversionMap.USA[data[data.length - 1]];
            data = data.slice(0, data.length - 1);
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    address.city = data[i];
                } else {
                    address.city = address.city + " " + data[i];
                }
            }
            address.country = "USA";
            return address;
        } catch {
            return null;
        }
    }

    public parseCanadianAddress(description: string, text: string): ParsedAddress {
        try {
            const address = {
                streetAddress: "",
                country: "",
                state: "",
                city: "",
                zipCode: "",
                moreAddresses: false,
                id: ""
            }
            address.streetAddress = text;
            let data = description.split(",");
            address.zipCode = data[data.length - 1].substr(1, 7).replace(/\s/g, '');
            data = data.slice(0, data.length - 1);
            address.state = this.stateConversionMap.CAN[data[data.length - 1].replace(/\s/g, '')];
            data = data.slice(0, data.length - 1);
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    address.city = data[i];
                } else {
                    address.city = address.city + " " + data[i];
                }
            }
            address.country = "CAN";
            return address;
        } catch {
            return null;
        }
    }

    public parseMexicanAddress(description: string, text: string): ParsedAddress {
        return null;
    }
}

export default new AddressParser();


// WEBPACK FOOTER //
// ./src/services/AddressParser.ts